/** Operator-console (apps/admin) French strings — `admin` i18n namespace. */
export default {
  nav: {
    users: 'Utilisateurs',
    accounts: 'Comptes',
    transactions: 'Transactions',
    fx_conversions: 'Conversions FX',
    reviews: 'Revues',
    risk_assessments: 'Évaluations de risque',
    security: 'Sécurité',
    kyc: 'Revues KYC',
    audit_logs: "Journaux d'audit",
    webhooks: 'Webhooks',
    business_model: 'Modèle économique',
    sign_out: 'Se déconnecter',
  },
  login: {
    title: 'Console opérateur',
    subtitle: 'Connecte-toi pour continuer.',
    email_label: 'Adresse e-mail',
    password_label: 'Mot de passe',
    submit: 'Se connecter',
    twofa_code_label: "Code d'authentification",
    twofa_submit: 'Vérifier',
    not_authorized: "Ce compte n'a pas d'accès opérateur.",
  },
  common: {
    loading: 'Chargement…',
    none: '—',
    page: 'Page {{page}}',
    prev: 'Précédent',
    next: 'Suivant',
    search: 'Rechercher',
    filter: 'Filtrer',
    all: 'Tous',
    back: 'Retour',
    refresh: 'Actualiser',
  },
  users: {
    title: 'Utilisateurs',
    search_placeholder: 'Rechercher par e-mail…',
    status_filter: 'Statut',
    col_email: 'E-mail',
    col_status: 'Statut',
    col_plan: 'Offre',
    col_kyc: 'KYC',
    col_created: 'Créé le',
    empty: 'Aucun utilisateur correspondant.',
  },
  user_detail: {
    title: 'Détail utilisateur',
    section_profile: 'Profil',
    section_actions: 'Actions',
    section_audit: "Journal d'audit",
    email: 'E-mail',
    status: 'Statut',
    plan: 'Offre',
    kyc: 'Statut KYC',
    role: 'Rôle',
    created: 'Créé le',
    suspend: 'Suspendre le compte',
    suspend_reason: 'Motif (interne)',
    reactivate: 'Réactiver',
    force_logout: 'Forcer la déconnexion globale',
    audit_empty: "Aucune entrée d'audit.",
    col_action: 'Action',
    col_time: 'Date',
  },
  statuses: {
    pending_email: 'E-mail en attente',
    pending_kyc: 'KYC en attente',
    active: 'Actif',
    review: 'En revue',
    suspended: 'Suspendu',
    closed: 'Clôturé',
  },
  kyc: {
    title: 'Revues KYC',
    subtitle: 'La vérification reste chez Sumsub — supervision en lecture seule.',
    col_user: 'Utilisateur',
    col_tier: 'Niveau',
    col_status: 'Statut',
    col_created: 'Démarré le',
    empty: 'Aucune revue en attente.',
  },
  audit: {
    title: "Journaux d'audit",
    filter_action: "L'action contient…",
    filter_resource: 'Type de ressource',
    col_action: 'Action',
    col_actor: 'Acteur',
    col_resource: 'Ressource',
    col_time: 'Date',
    empty: 'Aucune entrée correspondante.',
  },
  webhooks: {
    title: 'Webhooks',
    col_source: 'Source',
    col_type: 'Type',
    col_valid: 'Signature',
    col_processed: 'Traité',
    col_created: 'Reçu le',
    empty: 'Aucun webhook reçu.',
    valid_yes: 'Valide',
    valid_no: 'Invalide',
  },
  accounts: {
    title: 'Comptes',
    status_filter: 'Statut',
    col_owner: 'Titulaire',
    col_iban: 'IBAN',
    col_status: 'Statut',
    col_balance: 'Solde',
    col_created: 'Ouvert le',
    empty: 'Aucun compte correspondant.',
  },
  account_statuses: {
    opening: 'En ouverture',
    opened: 'Ouvert',
    review: 'En revue',
    suspended: 'Suspendu',
    closed: 'Clôturé',
  },
  transactions: {
    title: 'Transactions',
    search_placeholder: 'Nom, IBAN, référence…',
    status_filter: 'Statut',
    col_owner: 'Titulaire',
    col_type: 'Type',
    col_amount: 'Montant',
    col_status: 'Statut',
    col_date: 'Date',
    empty: 'Aucune transaction correspondante.',
  },
  reviews: {
    title: 'Revues',
    queue_title: 'File de revues',
    queue_subtitle: "Les plus anciennes d'abord. Résous ou assigne-toi les revues.",
    empty: 'Aucune revue en cours.',
    started: 'Démarrée le',
    escalated: 'Escaladée (plus de 24 h)',
    resolve: 'Résoudre',
    assign_me: "M'assigner",
  },
  review_types: {
    kyc_refresh: "Mise à jour d'identité",
    transaction_review: 'Revue de transaction',
    aml_check: 'Contrôle conformité',
    fraud_check: 'Contrôle fraude',
    other: 'Autre',
  },
  review_statuses: {
    in_progress: 'En cours',
    resolved: 'Résolue',
    escalated: 'Escaladée',
  },
  security: {
    title: 'Événements de sécurité',
    subtitle: "Signal de détection — rafales d'échecs de login, signatures webhook invalides, anomalies.",
    severity_filter: 'Sévérité',
    col_time: 'Date',
    col_severity: 'Sévérité',
    col_event: 'Événement',
    col_ip: 'IP',
    col_user: 'Utilisateur',
    empty: 'Aucun événement de sécurité.',
  },
  severities: {
    info: 'Info',
    warning: 'Avertissement',
    high: 'Élevé',
    critical: 'Critique',
  },
  risk: {
    title: 'Évaluations de risque',
    subtitle:
      'Pré-vérifications escaladées. Les signaux sont internes — jamais communiqués au client.',
    empty: 'Aucune évaluation escaladée.',
    score: 'Score {{score}}/100',
    justification: 'Justification du client',
    view_doc: 'Voir le document',
    created: 'Créée le',
    reason_placeholder: 'Motif de décision (interne, audité)',
    approve: 'Approuver',
    reject: 'Rejeter',
    flags: {
      unusual_amount: 'Montant inhabituel',
      sensitive_country: 'Destination sensible',
      new_beneficiary: 'Nouveau bénéficiaire',
      high_frequency: 'Fréquence élevée',
      round_amount_structuring: 'Montant rond (structuration)',
      just_below_threshold: 'Juste sous le seuil',
      peak_unusual_time: 'Heure inhabituelle',
    },
  },
  fx: {
    title: 'Conversions FX',
    subtitle: 'Conversions intra-UE — taux mid-market vs appliqué et marge déclarée.',
    status_filter: 'Statut',
    col_user: 'Utilisateur',
    col_from: 'Depuis',
    col_to: 'Vers',
    col_mid_rate: 'Mid-market',
    col_applied_rate: 'Appliqué',
    col_margin: 'Marge',
    col_status: 'Statut',
    col_date: 'Date',
    empty: 'Aucune conversion correspondante.',
  },
  business_model: {
    title: 'Chiffres du modèle économique',
    subtitle: 'Revenus mensuels affichés sur la page publique. La publication est auditée.',
    form_title: 'Ajouter ou mettre à jour un mois',
    period: 'Période (AAAA-MM)',
    subscriptions: 'Abonnements (€)',
    interchange: 'Interchange carte (€)',
    fx_margin: 'Marge FX (€)',
    paylink: 'Pay-by-link (€)',
    notes: 'Notes (interne)',
    save: 'Enregistrer les chiffres',
    list_title: 'Mois publiés & brouillons',
    col_period: 'Période',
    col_total: 'Total',
    col_status: 'Statut',
    col_actions: 'Actions',
    published: 'Publié',
    draft: 'Brouillon',
    edit: 'Modifier',
    publish: 'Publier',
    unpublish: 'Dépublier',
    empty: 'Aucun chiffre pour le moment.',
    updated_hint: 'Dernière mise à jour {{date}}.',
  },
} as const
